import React, { useCallback, useEffect, useState } from "react";
import Switch from "../ui/Switch";
import refreshIcon from "../../assets/icons/refresh-cw.svg";

export const AUTO_REFRESH_MS = 5 * 60 * 1000;

const readAutoRefresh = (storageKey) =>
    typeof localStorage !== "undefined" && localStorage.getItem(storageKey) === "1";

export const useAutoRefresh = (onRefresh, storageKey) => {
    const [autoRefresh, setAutoRefresh] = useState(() => readAutoRefresh(storageKey));

    useEffect(() => {
        if (!autoRefresh) return undefined;
        const id = setInterval(() => onRefresh(), AUTO_REFRESH_MS);
        return () => clearInterval(id);
    }, [autoRefresh, onRefresh]);

    const handleAutoRefreshChange = useCallback(
        (enabled) => {
            setAutoRefresh(enabled);
            if (typeof localStorage !== "undefined") localStorage.setItem(storageKey, enabled ? "1" : "0");
            // Refresh immediately when switching on, so it reloads without waiting a full cycle.
            if (enabled) onRefresh();
        },
        [onRefresh, storageKey]
    );

    return [autoRefresh, handleAutoRefreshChange];
};

// Refreshing is global across the Commercial tabs: `onRefresh` reloads both the
// Checklist deals and the Task List, whichever tab the control is rendered on.
export const RefreshControl = ({ spinning, autoRefresh, onToggle, onRefresh, lastUpdated }) => (
    <div className="commercial__refresh">
        <div className="commercial__refresh-toggle">
            <button
                type="button"
                className="commercial__refresh-button"
                onClick={onRefresh}
                disabled={spinning}
                title="Refresh checklist and task list"
                aria-label="Refresh checklist and task list"
            >
                <img
                    src={refreshIcon}
                    alt=""
                    className={`commercial__refresh-icon${spinning ? " commercial__refresh-icon--spinning" : ""}`}
                />
            </button>
            <span className="commercial__refresh-label">Auto-refresh</span>
            <Switch
                isOn={autoRefresh}
                value={onToggle}
                classNames={["commercial__refresh-switch"]}
                ariaLabel={`Auto-refresh every ${AUTO_REFRESH_MS / 60000} minutes`}
            />
        </div>
        {lastUpdated && <span className="commercial__updated">Updated {lastUpdated.toLocaleTimeString()}</span>}
    </div>
);
